import axios from "axios";
import { PacoteDTO } from "../common/PacoteContext/PacoteContext";

const BASE_URL = process.env.REACT_APP_API_URL;

export const getPacoteById = async (id: string): Promise<PacoteDTO> => {
  const { data } = await axios.get(`${BASE_URL}/pacotes/${id}`);
  return data;
};
